import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import LockClockRoundedIcon from '@mui/icons-material/LockClockRounded';
import ShortTextRoundedIcon from '@mui/icons-material/ShortTextRounded';
import EditModal from "../../../components/editModal/editModal";
import useEntity from "../../../api/useEntity";
import moment from "moment";
import "./tankkarten.scss"

const Tankkarten = () => {
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get("/tankstelle/rfidcards");
            setItems(res.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "tankstelle/rfidcards",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    function cardFormat(value) { return String(value ?? "").match(/.{1,2}/g)?.join("-") ?? ""; }

    return (
        <div className="tankkarten">
            <button className="add" onClick={() => setSelectedItem(true)}>Tankkarte hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Karten Nr.</th>
                            <th>Beschreibung</th>
                            <th>Verbrauch (Letzen 30 Tage)</th>
                            <th>Gültig bis</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td className="cardNr">
                                    <div className="grid">
                                        <CreditCardRoundedIcon />
                                        <bold>{cardFormat(i.idToken)}</bold>
                                    </div>
                                </td>
                                <td>{i.description}</td>
                                <td>850 kW/h</td>
                                <td>{i.revokedAt && moment(i.revokedAt).format('L')}</td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {selectedItem && (
                <EditModal
                    title="Tankkarte"
                    isLoading={isLoading}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <CreditCardRoundedIcon />
                        <input
                            type="text"
                            value={cardFormat(item.idToken)} placeholder="Karten Nr."
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    idToken: e.target.value.replace(/-/g, "")
                                }))
                            }
                            disabled={item.id}
                        />
                    </div>
                    <div className="group">
                        <ShortTextRoundedIcon />
                        <input
                            type="text"
                            value={item.description}
                            placeholder="Beschreibung"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    description: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <LockClockRoundedIcon />
                        <input
                            type="date"
                            value={item.revokedAt ? moment(item.revokedAt).format("YYYY-MM-DD") : ""}
                            placeholder="Deaktiviert am"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    revokedAt: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                        </div>
                    </div>
                </EditModal>
            )}
        </div>
    )
};

export default Tankkarten